import {adapter} from "./adapter";

export const servicioObtenerVehiculos= () => {
    const endPoint = `/api/configura/modelos`;
    return adapter(endPoint, "GET", null);
};



